/**
 * Onde o token do convite espera enquanto a pessoa cria a conta.
 *
 * Quem chega por um link de convite sem ter conta passa por cadastro,
 * confirmação de e-mail e onboarding — três telas que trocam a URL. Sem guardar
 * o token, ao final de tudo a pessoa cairia na tela Hoje e o convite estaria
 * perdido: ele vive numa URL que ninguém mais tem.
 *
 * **`sessionStorage`, não `localStorage`.** O token expira com a aba. Um convite
 * esquecido no aparelho por semanas, sobrevivendo a reinícios, seria um segredo
 * de uso único guardado bem além do necessário.
 */

const KEY = 'movhuman.pendingInvite';

export function rememberInvite(token: string): void {
  sessionStorage.setItem(KEY, token);
}

/** Lê **e apaga**: retomar duas vezes seria um laço entre telas. */
export function takeRememberedInvite(): string | null {
  const token = sessionStorage.getItem(KEY);
  if (token) sessionStorage.removeItem(KEY);
  return token;
}
